/**
 * Columbia Tech Category Block
 * - Compare popup: open/close by data-compare-trigger and data-compare-close
 * - Learn More popup: open from .columbia-tech-card[data-learn-more-card], show panel by data-tech-handle
 */
(function () {
  function init() {
    const triggers = document.querySelectorAll('[data-compare-trigger]');
    const closeButtons = document.querySelectorAll('[data-compare-close]');
    const learnMoreCloseButtons = document.querySelectorAll('[data-learn-more-close]');

    function openLearnMorePopup(techHandle, sectionRoot) {
      if (!techHandle || !sectionRoot) return;
      const modal = sectionRoot.querySelector('[data-learn-more-modal]');
      if (!modal) return;
      const modalPanel = modal.querySelector('.columbia-tech-learn-more-popup__panel');
      const panels = modal.querySelectorAll('[data-learn-more-panel]');
      panels.forEach(function (panel) {
        if (panel.getAttribute('data-tech-handle') === techHandle) {
          panel.removeAttribute('hidden');
          if (modalPanel) {
            modalPanel.classList.toggle('is-single-card', panel.hasAttribute('data-learn-more-single-card'));
          }
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      const focusTarget = modal.querySelector('[data-learn-more-close]') || modal.querySelector('.columbia-tech-compare-popup__close');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-compare-trigger');
        const modal = id ? document.getElementById(id) : null;
        if (modal && modal.hasAttribute('data-compare-modal')) {
          modal.removeAttribute('hidden');
          modal.setAttribute('aria-hidden', 'false');
          const titleId = modal.getAttribute('aria-labelledby');
          if (titleId) {
            const titleEl = document.getElementById(titleId);
            if (titleEl) titleEl.focus({ preventScroll: true });
          }
          document.body.style.overflow = 'hidden';
        }
      });
    });

    function closeModal(modal) {
      if (!modal) return;
      var isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        modal.classList.add('is-closing');
        var panel = modal.querySelector('.columbia-tech-compare-popup__panel');
        function onAnimationEnd() {
          panel.removeEventListener('animationend', onAnimationEnd);
          modal.classList.remove('is-closing');
          modal.setAttribute('hidden', '');
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
        if (panel) {
          panel.addEventListener('animationend', onAnimationEnd);
        } else {
          onAnimationEnd();
        }
      } else {
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const modal = this.closest('.columbia-tech-compare-popup');
        closeModal(modal);
      });
    });

    document.addEventListener('click', function (e) {
      var card = e.target.closest('.columbia-tech-card[data-learn-more-card]');
      if (!card) return;
      if (e.target.closest('a[href], button')) return;
      var root = card.closest('.columbia-tech-category-block');
      if (!root) return;
      var handle = card.getAttribute('data-tech-handle');
      openLearnMorePopup(handle, root);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = e.target.closest('.columbia-tech-card[data-learn-more-card]');
      if (!card || e.target !== card) return;
      e.preventDefault();
      var root = card.closest('.columbia-tech-category-block');
      if (!root) return;
      openLearnMorePopup(card.getAttribute('data-tech-handle'), root);
    });

    learnMoreCloseButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const modal = this.closest('[data-learn-more-modal]');
        if (!modal) return;
        const modalPanel = modal.querySelector('.columbia-tech-learn-more-popup__panel');
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (modalPanel) {
          modalPanel.classList.remove('is-single-card');
        }
        const panels = modal.querySelectorAll('[data-learn-more-panel]');
        panels.forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      const openCompare = document.querySelector('.columbia-tech-compare-popup[data-compare-modal]:not([hidden])');
      if (openCompare) {
        closeModal(openCompare);
        return;
      }
      const openLearnMore = document.querySelector('[data-learn-more-modal]:not([hidden])');
      if (openLearnMore) {
        const modalPanel = openLearnMore.querySelector('.columbia-tech-learn-more-popup__panel');
        openLearnMore.setAttribute('hidden', '');
        openLearnMore.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (modalPanel) {
          modalPanel.classList.remove('is-single-card');
        }
        const panels = openLearnMore.querySelectorAll('[data-learn-more-panel]');
        panels.forEach(function (panel) {
          panel.setAttribute('hidden', '');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
